/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Step_PlaceInputs */

const vi_care_log_step_place = /** @type {(inputs: Care_Log_Step_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

/**

* @param {Care_Log_Step_PlaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_step_place = /** @type {((inputs?: Care_Log_Step_PlaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Step_PlaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_step_place(inputs)
});